import * as dataProvider from "../../typeahead/helpers/dataProvider"
import React from "react"
import ReactDOM from "react-dom"
import * as endpoints from "../../api/endpoints"
import TypeaheadSearchResults from "./typeahead-search-results"

export default class FullWidthTypeaheadBannerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.searchInput = elem.querySelector("[data-input-search]")
    self.elem.searchResultContainer = elem.querySelector(".js-search-result-container")
    self.clearSearchFieldOnClose = true
    self.language = document.body && document.body.dataset.language
    self.init()
    return self
  }

  init() {
    const self = this
    if (self.elem.searchInput) {
      self.elem.searchInput.addEventListener("input", (event) => self.handleSearch(event))
      self.elem.searchInput.addEventListener("blur", (event) => self.handleRemoveSearch(event))
    }
  }

  getDataConfig() {
    const self = this
    const input = self.elem.searchInput
    if (input) {
      const config = input.dataset.inputSearch ? JSON.parse(input.dataset.inputSearch) : {}
      return config
    }
  }

  handleSearch = async (event) => {
    const self = this
    const { target } = event
    const fetchData = { query: target.value, language: self.language }
    const response = await this.getData(fetchData)
    if (response && response.data) {
      self.mountSearchResults(response.data, target.value)
    } else {
      self.mountSearchResults({}, target.value)
    }
  }

  getData = (data) => {
    return endpoints.getArticlesTypeahead(data)
  }

  mountSearchResults = (data, query) => {
    const self = this
    const searchResultContainer = self.elem.searchResultContainer
    const { filteredData, displayGroupNames } = dataProvider.createPageData(data, this.getDataConfig())
    if (searchResultContainer) {
      if (query.length > 0) {
        ReactDOM.unmountComponentAtNode(searchResultContainer)
        ReactDOM.render(
          <TypeaheadSearchResults
            dataConfig={this.getDataConfig()}
            data={filteredData}
            displayGroupNames={displayGroupNames}
            noResults={self.elem.searchInput.dataset.noResults}
            query={query}
          />,
          searchResultContainer,
        )
      } else {
        ReactDOM.unmountComponentAtNode(searchResultContainer)
      }
    }
  }

  handleRemoveSearch(event) {
    const { target } = event
    setTimeout(() => {
      if (this.clearSearchFieldOnClose) {
        target.value = ""
      }
      this.handleSearch(event)
    }, 100)
  }
}
